export default __webpack_public_path__ + "static/media/eth.aeb7919b.png";